<template>
  <div class="modal-overlay" v-if="visible && participant" @click.self="$emit('close')">
    <div class="modal-card details-modal">
      <button class="close-btn" type="button" @click="$emit('close')" aria-label="Fechar">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"/></svg>
      </button>

      <header class="details-header">
        <h2 class="details-name">{{ participant.name }}</h2>
        <EquipeChip :equipe="participant.equipe" />
      </header>

      <div class="status-banner" :class="participant.check ? 'banner-confirmed' : 'banner-pending'">
        <svg v-if="participant.check" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="m10.6 16.6l7.05-7.05l-1.4-1.4l-5.65 5.65l-2.85-2.85l-1.4 1.4l4.25 4.25ZM12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Z"/></svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m.5-13H11v6l5.2 3.2l.8-1.3l-4.5-2.7V7Z"/></svg>
        <span>{{ participant.check ? 'Check-in confirmado' : 'Aguardando check-in' }}</span>
      </div>

      <dl class="details-list">
        <div class="details-row">
          <dt>Contato</dt>
          <dd>{{ participant.contato || '—' }}</dd>
        </div>

        <template v-if="participant.check">
          <div class="details-row">
            <dt>Transporte</dt>
            <dd>
              <TransporteBadge v-if="participant.transporte" :value="participant.transporte" />
              <span v-else class="text-muted">—</span>
            </dd>
          </div>

          <div class="details-row">
            <dt>Horário do check-in</dt>
            <dd>{{ formatDateTime(participant.checkedAt) }}</dd>
          </div>

          <div class="details-row">
            <dt>Confirmado por</dt>
            <dd>{{ participant.checkedBy?.name || 'Sem login' }}</dd>
          </div>
        </template>

        <div class="details-row">
          <dt>Cadastrado por</dt>
          <dd>{{ participant.createdBy?.name || '—' }}</dd>
        </div>

        <div class="details-row">
          <dt>Cadastrado em</dt>
          <dd>{{ formatDateTime(participant.createdAt) }}</dd>
        </div>
      </dl>

      <div class="modal-actions">
        <button class="btn-secondary" @click="$emit('close')">Fechar</button>
        <button class="btn-secondary" @click="$emit('qr')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M3 11h8V3H3v8zm2-6h4v4H5V5zm-2 16h8v-8H3v8zm2-6h4v4H5v-4zm8-12v8h8V3h-8zm6 6h-4V5h4v4zm0 4h-2v2h2v-2zM11 13H9v4h2v-2h2v-2h-2v0zm6 0h-2v2h2v-2zm-2 4h-2v2h2v-2zm2-2h2v-2h-2v2zm0 6h2v-4h-2v4z"/></svg>
          QR Code
        </button>
        <button class="btn-primary" @click="$emit('edit')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83l3.75 3.75l1.83-1.83z"/></svg>
          Editar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EquipeChip from './EquipeChip.vue'
import TransporteBadge from './TransporteBadge.vue'

export default {
  name: 'AcampanteDetailsModal',
  components: { EquipeChip, TransporteBadge },
  props: {
    visible: { type: Boolean, default: false },
    participant: { type: Object, default: null }
  },
  emits: ['close', 'edit', 'qr'],
  methods: {
    formatDateTime(iso) {
      if (!iso) return '—'
      try {
        return new Date(iso).toLocaleString('pt-BR', {
          day: '2-digit', month: '2-digit', year: 'numeric',
          hour: '2-digit', minute: '2-digit'
        })
      } catch { return '—' }
    }
  }
}
</script>

<style scoped>
.details-modal {
  position: relative;
  max-width: 480px;
  padding: var(--spacing-lg);
}
.close-btn {
  position: absolute;
  top: 12px; right: 12px;
  width: 32px; height: 32px;
  display: inline-flex; align-items: center; justify-content: center;
  background: none; border: none; cursor: pointer;
  color: var(--color-text-muted);
  border-radius: var(--radius-circle);
  transition: var(--transition-fast);
}
.close-btn:hover { background: var(--color-bg-hover); color: var(--color-text-primary); }

.details-header {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  flex-wrap: wrap;
  padding-right: var(--spacing-lg);
  margin-bottom: var(--spacing-base);
}
.details-name {
  font-size: var(--text-xl);
  font-weight: 800;
  color: var(--color-text-primary);
  margin: 0;
  word-break: break-word;
}

.status-banner {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: 8px 14px;
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  font-weight: 700;
  margin-bottom: var(--spacing-base);
}
.banner-confirmed {
  background: rgba(46, 204, 113, 0.12);
  color: var(--color-success);
}
.banner-pending {
  background: rgba(243, 156, 18, 0.12);
  color: var(--color-warning);
}

.details-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  margin: 0 0 var(--spacing-lg);
}
.details-row {
  display: grid;
  grid-template-columns: 160px 1fr;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-sm) 0;
  border-bottom: 1px solid var(--color-bg-separator);
}
.details-row:last-child { border-bottom: none; }
.details-row dt {
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--color-text-muted);
}
.details-row dd {
  margin: 0;
  font-size: var(--text-sm);
  color: var(--color-text-primary);
  word-break: break-word;
}
.text-muted { color: var(--color-text-muted); }

.modal-actions {
  display: flex;
  gap: var(--spacing-sm);
  justify-content: flex-end;
  flex-wrap: wrap;
}

@media (max-width: 480px) {
  .details-row { grid-template-columns: 1fr; gap: 4px; }
  .details-row dd { font-size: var(--text-md); }
  .modal-actions { flex-direction: column-reverse; }
  .modal-actions button { width: 100%; justify-content: center; }
}
</style>
